export default function ESFP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “سرگرم&zwnj;کننده”</h1>{" "}
          <blockquote>
            <p>
              من خودخواه، بی&zwnj;حوصله و کمی متزلزل هستم. من مرتکب اشتباه
              می&zwnj;شوم، کنترل خود را از دست می&zwnj;دهم و گاهی اوقات
              نمی&zwnj;شود تحملم کرد. اما اگر نتوانید وقتی در بدترین حالت هستم
              مرا تحمل کنید، قطعاً شایستگی وقتی در بهترین حالت خود هستم را
              ندارید.
            </p>{" "}
            <footer>Marilyn Monroe</footer>
          </blockquote>{" "}
          <p>
            اگر کسی را بتوان یافت که خود به خود به رقص و آواز بپردازد، گونه
            شخصیتی وی سرگرم&zwnj;کننده است. سرگرم&zwnj;کنندگان در هیجان لحظه
            گرفتار می&zwnj;شوند و می&zwnj;خواهند بقیه نیز چنین احساسی داشته
            باشند. وقتی مسئله تشویق دیگران به میان می&zwnj;آید هیچ گونه شخصیتی
            دیگر به اندازه سرگرم&zwnj;کنندگان در بخشیدن زمان و انرژی خود
            سخاوتمند نیست، و هیچ گونه شخصیتی دیگری چنین سبک وسوسه&zwnj;انگیزی
            ندارد.
          </p>{" "}
          <h2>ما همگی ستاره هستیم ...</h2>{" "}
          <p>
            سرگرم&zwnj;کنندگان که ذاتاً سرگرم&zwnj;کننده به دنیا آمده&zwnj;اند
            عاشق این هستند که در کانون توجه باشند، اما جهان به تمامی صحنه است.
            بسیاری از افراد مشهور دارای گونه شخصیتی سرگرم&zwnj;کننده در واقع
            بازیگر هستند، اما این افراد دوست دارند برای دوستان خود نیز نمایش
            بدهند، با شوخ طبعی منحصر به فرد و فروتنانه گپ بزنند، توجه دیگران را
            جلب کنند و هر بار بیرون رفتن را تبدیل به نوعی مهمانی کنند.
            سرگرم&zwnj;کنندگان که افرادی کاملاً اجتماعی هستند و از
            ساده&zwnj;ترین چیزها لذت می&zwnj;برند و هیچ چیزی برای آنها
            لذت&zwnj;بخش&zwnj;تر از خوش گذراندن با گروهی از دوستان خوب نیست.
          </p>{" "}
          <p>
            البته این فقط یک ادعا نیست - سرگرم&zwnj;کنندگان دارای قوی&zwnj;ترین
            حس زیبایی&zwnj;شناسی نسبت به تمام گونه&zwnj;های شخصیتی دیگر هستند.
            شخصیت&zwnj;های سرگرم&zwnj;کننده از آرایش گرفته تا لباس و
            خانه&zwnj;ای در مکانی مناسب، مشتاق مد هستند. سرگرم&zwnj;کنندگان که
            به محض دیدن چیزی متوجه می&zwnj;شوند جذاب است یا خیر، از تغییر محیط
            اطراف خود برای انعکاس دادن سبک شخصی&zwnj;شان نمی&zwnj;ترسند.
            سرگرم&zwnj;کنندگان ذاتاً کنجکاو هستند و طرح&zwnj;ها و سبک&zwnj;های
            جدید را به&zwnj;راحتی امتحان می&zwnj;کنند.
          </p>{" "}
          <p>
            سرگرم&zwnj;کنندگان می&zwnj;دانند که احساسات دیگران همیشه نسبت به
            آنها مثبت نیست و ممکن است از این امر خوششان نیاید - اما در هر حال
            نسبت به احساسات دیگران بسیار حساس هستند. افراد دارای این گونه شخصیتی
            اغلب اولین کسانی هستند که به شخصی که مشکل دشوار خود را مطرح کرده
            باشد کمک می&zwnj;کند و با خوشحالی حمایت عاطفی و توصیه&zwnj;های عملی
            ارائه می&zwnj;کنند. با این حال، اگر مشکل مربوط به خود
            سرگرم&zwnj;کنندگان باشد، به احتمال زیاد بجای پرداختن به آن، از درگیر
            شدن با آن خودداری می&zwnj;کنند. شخصیت&zwnj;های سرگرم&zwnj;کننده
            معمولاً عاشق درامی کوچک و پرشور هستند، اما وقتی انتقادات از آنها
            مطرح شود چندان علاقه&zwnj;ای به آن ندارند.
          </p>{" "}
          <h2>... و ما لایق درخشش هستیم</h2>{" "}
          <p>
            بزرگ&zwnj;ترین چالشی که سرگرم&zwnj;کنندگان با آن مواجه هستند این است
            که آنها اغلب چنان غرق در لذت&zwnj;های آنی هستند که به وظایف و
            مسئولیت&zwnj;هایی که چنین تجملاتی را ممکن ساخته است توجهی ندارند.
            تحلیل پیچیده، کارهای تکراری، و تطبیق آمار با عواقب واقعی
            فعالیت&zwnj;هایی نیست که برای افراد دارای گونه شخصیتی
            سرگرم&zwnj;کننده آسان باشد. آنها بیشتر به شانس یا فرصت تکیه
            می&zwnj;کنند، یا صرفاً از دایره گسترده دوستان خود کمک می&zwnj;گیرند.
            مهم است که سرگرم&zwnj;کنندگان برای پیگیری امور طولانی&zwnj;مدت مانند
            طرح&zwnj;های بازنشستگی خود و یا مصرف قند به خودشان فشار بیاورند -
            زیرا همیشه اشخاص دیگری در اطرافشان نیستند که بتوانند مراقب این مسائل
            باشند.
          </p>{" "}
          <p>
            شخصیت&zwnj;های سرگرم&zwnj;کننده ارزش و کیفیت را تشخیص می&zwnj;دهند
            که به&zwnj;خودی خود صفت خوبی است. هرچند این امر در کنار ضعف
            برنامه&zwnj;ریزی آنها، می&zwnj;تواند باعث شود بیشتر از حد وسع خود
            هزینه کنند و به&zwnj;ویژه کارت&zwnj;های اعتباری برایشان خطرناک است.
            سرگرم&zwnj;کنندگان که بیشتر بر استفاده کردن از فرصت&zwnj;ها تمرکز
            دارند تا بر برنامه&zwnj;ریزی اهداف بلندمدت، ممکن است دریابند که
            بی&zwnj;توجهی آنها باعث شده هزینه برخی از فعالیت&zwnj;ها خارج از
            توانشان باشد.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              برای شخصی با گونه شخصیتی سرگرم&zwnj;کننده هیچ چیزی
              ناراحت&zwnj;کننده&zwnj;تر از این نیست که متوجه بشود به خاطر شرایط
              گیر افتاده است و نمی&zwnj;تواند به دوستان خود ملحق شود.
            </p>
          </blockquote>{" "}
          <p>
            هر جا که نیاز به خنده، بازیگوشی و فرد داوطلب امتحان کردن چیزی تازه و
            سرگرم&zwnj;کننده وجود داشته باشد از سرگرم&zwnj;کنندگان استقبال
            می&zwnj;شود - و برای شخصیت&zwnj;های سرگرم&zwnj;کننده هیچ شادی بیشتر
            از این وجود ندارد که دیگران را با خود به سواری ببرند.
            سرگرم&zwnj;کنندگان می&zwnj;توانند ساعت&zwnj;ها حرف بزنند، گاهی اوقات
            در مورد هر چیزی بجز موضوع اصلی بحث مورد نظر، و با احساسات عزیزان خود
            در هنگام خوشی و ناخوشی همدلی کنند. اگر بتوانند کارهایشان را سر و
            سامان بدهند، همیشه آماده هستند چیزهای تازه و هیجان&zwnj;انگیزی که
            جهان عرضه کرده است را با دوستان خود امتحان کنند.
          </p>
        </article>
      </div>
    </div>
  );
}
